import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { ReactComponent } from '@sketch/icons/chevrons-up-down-16';

const Chevrons = ({ className }) => (jsx(ReactComponent, { className: className, height: "16px" }));
const DropdownChevrons = styled(Chevrons).attrs({ role: 'img' }) ``;

export { DropdownChevrons };
